import { render, staticRenderFns } from "./SkinsImportTable.vue?vue&type=template&id=3efe4c07&"
import script from "./SkinsImportTable.vue?vue&type=script&lang=js&"
export * from "./SkinsImportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports